import {combineReducers} from "redux";

import mainViewModel from "./mainViewModel";
import nursingStaff from "./nursingstaff/index";
import setting from "./setting/index";
import myArchive from "./myarchive/index";
import approval from "./approval/index";
import govLetter from "./govletter/index";
import homepage from "./homepage/index";
import systemSetting from "./systemsetting/index";
import mediGroup from "./medigroup/index";
import accountSetting from "./accountsetting/index";
import indexViewModel from "./indexViewModel";
import developcenter from "./developcenter";
import other from "./other";
import swjwLoginViewModel from "./swjwLoginViewModel";
import swjwLoginMainViewModel from "./swjwLoginMainViewModel";

const rootViewModel = combineReducers({
    mainViewModel,
    setting,
    nursingStaff,
    myArchive,
    approval,
    govLetter,
    homepage,
    systemSetting,
    mediGroup,
    accountSetting,
    indexViewModel,
    developcenter,
    swjwLoginViewModel,
    other,
    swjwLoginMainViewModel,
});

export default rootViewModel;
